var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5525 7.74008C13.41 7.74008 13.2675 7.68758 13.155 7.57508L9 3.42008L4.845 7.57508C4.6275 7.79258 4.2675 7.79258 4.05 7.57508C3.8325 7.35758 3.8325 6.99758 4.05 6.78008L8.6025 2.22758C8.82 2.01008 9.18 2.01008 9.3975 2.22758L13.95 6.78008C14.1675 6.99758 14.1675 7.35758 13.95 7.57508C13.845 7.68758 13.695 7.74008 13.5525 7.74008Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.9374C8.6925 15.9374 8.4375 15.6824 8.4375 15.3749V2.75244C8.4375 2.44494 8.6925 2.18994 9 2.18994C9.3075 2.18994 9.5625 2.44494 9.5625 2.75244V15.3749C9.5625 15.6824 9.3075 15.9374 9 15.9374Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlack);
export default __webpack_public_path__ + "static/media/arrow-up_black.39217feee441bb515abe2ef628ed7177.svg";
export { ForwardRef as ReactComponent };